import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClientModule, HttpClient, HttpParams } from '@angular/common/http';
import { of, ObservableInput } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class AirportsService {

  airports;
  public flattenAirports;

  private airportsObj = new BehaviorSubject<any>([]);
  airportsObjsObs = this.airportsObj.asObservable();

  constructor(private http: HttpClient) { }

  getAirports(countryCode?: String, lat?, lng?, iataCodes?: Array<String>, lang?): Observable<any> {
    const countriesURL = environment.apiUrl.baseUrl + environment.apiUrl.services.airports;
    let params;
    params = new HttpParams();
    if (countryCode) {
      params = params.append('country_code', countryCode);
    }
    if (iataCodes) {
      iataCodes.forEach(code => {
        params = params.append('airport_iata_code[]', code);
      });
    }
    if (lat) {
      params = params.append('latitude', lat);
    }
    if (lng) {
      params = params.append('longitude', lng);
    }
    if (lang) {
      params = params.append('language_code', lang);
    }
    return this.http
      .get(countriesURL, { params: params })
      .pipe(map(
        (response: any) => {
          this.flattenAirports = JSON.parse(JSON.stringify(response.airports));
          this.changeAirportsObj(JSON.parse(JSON.stringify(response.airports)));
          return response;
        },
        error => {
          console.warn(error);
          return error;
        }
      ));
  }

  changeAirportsObj(airports) {
    const _val = this.adjustAirportsObject(airports);
    this.airports = _val;
    this.airportsObj.next(_val);
  }

  adjustAirportsObject(obj) {
    // const arrangedObj = obj.sort((a, b) => a.id - b.id);
    const arrangedObj = obj;
    arrangedObj.forEach(ele => {
      if (ele.parent_id > 0) {
        const tempObj = ele;
        arrangedObj.forEach(el => {
          /* tslint:disable */
          if (el && el.id == ele.parent_id) {
            if (!el.children) {
              el.children = [];
            }
            el.children.push(tempObj);
            return;
          }
          /* tslint:enable */
        });
        const index = arrangedObj.findIndex(x => {
          if (x && x.id === ele.id) {
            return x;
          }
        });
        if (index) {
          delete arrangedObj[index];
        }
      }
    });
    const filteredArray = arrangedObj.filter(function (el) {
      return el != null;
    });
    return filteredArray;
  }

  getDistanceBetweenTwoPoints(lat1, lat2, lon1, lon2) {
    // https://www.barattalo.it/coding/decimal-degrees-conversion-and-distance-of-two-points-on-google-map/
    const R = 6371; // km (change this constant to get miles)
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    if (d > 1) {
      return Math.round(d);
    } else if (d <= 1) {
      return Math.round(d * 1000) + ' m';
    }
    return d;
  }

  getAllAirports() {
    if (this.airports) {
      return this.airports;
    } else {
      this.getAirports().subscribe((res) => {
        return res;
      }, (error) => {
        return error;
      });
    }
  }

  getAirportObjectByIATACode(iataCode, countryCode) {
    if (this.airports) {
      const _allAirports = this.airports;
      for (let i = 0; i < _allAirports.length; i++) {
        const airportObj = _allAirports[i];
        if (airportObj.iata_code === iataCode) {
          return airportObj;
        }
      }
    } else {
      return this.getAirports(countryCode).subscribe((res) => {
        for (let i = 0; i < res.airports.length; i++) {
          const airportObj = res.airports[i];
          if (airportObj.iata_code === iataCode) {
            return airportObj;
          }
        }
      }, err => {
        console.warn(err);
      });
    }
    return this.getAirports().subscribe((res) => {
      for (let i = 0; i < res.airports.length; i++) {
        const airportObj = res.airports[i];
        if (airportObj.iata_code === iataCode) {
          return airportObj;
        }
      }
    }, err => {
      console.warn(err);
    });
  }
}
